"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("../form-definition/form-constants");
/**
 * Check if an element is a multiple-choice with "other" option group
 * @param element The form element to check
 * @returns True if element is an mc-other group, false otherwise
 */
function isMcOtherGroup(element) {
    return element.type === form_constants_1.elementTypes.group &&
        element.dataFormat &&
        element.dataFormat.type === form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER;
}
exports.isMcOtherGroup = isMcOtherGroup;
//# sourceMappingURL=element-type-helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/element-type-helpers.js
// module id = 1161
// module chunks = 0